(function () {
  var tracks = document.querySelectorAll('[data-community-carousel]');
  if (!tracks.length) return;

  tracks.forEach(function (track) {
    // Center the row instead of left-aligning with a big empty gap when there are few enough
    // posts that the track doesn't actually need to scroll — see initializeTrackCentering in
    // animations.js.
    if (typeof initializeTrackCentering === 'function') {
      initializeTrackCentering(track);
    }

    // Coverflow-style focus: whichever post is nearest the middle of the track scales up a
    // touch, the rest recede — see initializeScrollFocus in animations.js (loaded earlier in
    // <head>; guarded here in case animations were turned off in theme settings).
    if (typeof initializeScrollFocus !== 'function') return;

    var cards = track.querySelectorAll('[data-community-card]');
    var focusDelay = parseFloat(track.dataset.cardFocusDelay || '0') / 100;
    initializeScrollFocus(Array.from(cards), {
      axis: 'x',
      minScale: 0.96,
      maxScale: 1,
      delay: focusDelay,
      scrollContainer: track,
    });
  });
})();
